import React from "react";

import { createSvgIcon } from "@mui/material/utils";

export const SnapshotIcon = createSvgIcon(
 <svg
  id="Livello_1"
  data-name="Livello 1"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 20 20"
  fill="currentColor">
  <g id="Layer_3" data-name="Layer 3">
   <path d="M17.62,4.09h-1.67l-1.55-2.32c-.17-.25-.45-.41-.76-.4h-7.27c-.3,0-.59.15-.76.4l-1.55,2.32h-1.67c-1.32,0-2.38,1.07-2.38,2.38v9.78c0,1.32,1.07,2.38,2.38,2.38h15.23c1.32,0,2.38-1.07,2.38-2.38V6.48c0-1.32-1.07-2.38-2.38-2.38h0ZM18.18,16.25c0,.31-.25.57-.57.57H2.38c-.31,0-.57-.25-.57-.57V6.48c0-.31.25-.57.57-.57h2.16c.3,0,.59-.15.76-.4l1.55-2.32h6.3l1.55,2.32c.17.25.45.41.76.4h2.16c.31,0,.57.25.57.57v9.78Z" />
   <path d="M10,6.82c-2.01,0-3.64,1.63-3.64,3.64s1.63,3.64,3.64,3.64,3.64-1.63,3.64-3.64-1.63-3.64-3.64-3.64ZM10,12.27c-1,0-1.82-.81-1.82-1.82s.81-1.82,1.82-1.82,1.82.81,1.82,1.82-.81,1.82-1.82,1.82Z" />
  </g>
 </svg>,
 "Snapshot"
);
